export const ANALYTICS_BASE_URL =
  MODE === 'release'
    ? 'https://shopping-gpt-stat.buzzni.com'
    : 'https://dev-shopping-gpt-stat.buzzni.com';
